'use client';
const HIDE_ICON_BUTTON_TOOLTIP = Symbol('hideIconButtonTooltip');
const noTooltipInternal = {
    __dangerouslyHideTooltip: HIDE_ICON_BUTTON_TOOLTIP
};

export { HIDE_ICON_BUTTON_TOOLTIP, noTooltipInternal };
